// extracted by mini-css-extract-plugin
export default {"root":"nP8Xo962Vy","header":"U5cxnbfu42","itemsContainer":"Hq3KftzxlT"};